import { render } from "./AccessTree.vue?vue&type=template&id=0efb417c&scoped=true"
import script from "./AccessTree.vue?vue&type=script&lang=js"
export * from "./AccessTree.vue?vue&type=script&lang=js"

import "./AccessTree.vue?vue&type=style&index=0&id=0efb417c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0efb417c"]])

export default __exports__